
//https://api.thelottofactory.com/v1/member/tickets?ApiKey=1082e344-87a0-4257-ba86-04eac83c0730&Year=2016&Month=10
function MyTicketsMonthYearSvc($resource) {
  'ngInject';
  var odataUrl = TFL_Base_Url + 'member/tickets'
  return $resource(odataUrl, { }, {
      get: { method: 'GET', params: { APIKey: '@APIKey', Year: '@Year', Month: '@Month'}, isArray: true }
  });
};

export default {
  name: "MyTicketsMonthYearSvc",
  fn: MyTicketsMonthYearSvc
}